import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { getErrorHandlingOptions } from '../base/headers';
import { ZollerFocus } from '../../models/zoller-focus';
import { ZollerFocusBuilder } from '../../models/builders/zoller-focus.builder';

const zollerFocusBody = (zollerFocus: ZollerFocus) => ({
  name: zollerFocus.name
});

@Injectable()
export class ZollerFocusApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }zollerFocuses`;
  }

  getZollerFocuses() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(ZollerFocusBuilder.fromList)
      );
  }

  getZollerFocus(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(ZollerFocusBuilder.fromJson)
      );
  }

  createZollerFocus(zollerFocus) {
    return this.httpClient.post(this.apiUrl, zollerFocusBody(zollerFocus)).pipe(map(ZollerFocusBuilder.fromJson));
  }

  updateZollerFocus(zollerFocus: ZollerFocus) {
    return this.httpClient.put(`${ this.apiUrl }/${ zollerFocus.hash }`, zollerFocusBody(zollerFocus));
  }

  deleteZollerFocus(zollerFocus: ZollerFocus) {
    return this.httpClient.delete(`${ this.apiUrl }/${ zollerFocus.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/zoller-focus-api.service.ts